module.exports = __webpack_public_path__ + "img/razzo1.8eeb5a2d.webp";